/* eslint-disable react-hooks/rules-of-hooks */

import React, { useState, useEffect } from "react";
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import PageviewIcon from '@mui/icons-material/Pageview';
import { fetchData, removeMute } from "../../services/stacks.js";
import { useNavigate } from 'react-router-dom';
import './style.scss'; 

// Get and Set per Muted per fetched mutedlist.json from users storage
const Muted = () => {
  const [mutedList, setMutedList] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    async function getMutedList() {
      const result = await fetchData('mutedlist.json');
      if (result.success) {
        setMutedList(result.result);
      } else {
        setErrorMessage(result.result.message);
      }
    }

    getMutedList();
  }, []);

  const handleRemoveMute = async (id) => {
    try {
      const result = await removeMute(id);
      if (result.success) {
        const updatedMutedList = { ...mutedList };
        delete updatedMutedList[id];
        setMutedList(updatedMutedList);
      } else {
        setErrorMessage('Error while removing muted');
      }
    } catch (e) {
      setErrorMessage('Error while removing muted');
    }
  };

  if (errorMessage) {
    return (
      <div>
        <h2>Error: {errorMessage}</h2>
      </div>
    );
  }

  if (mutedList === null) {
    return (
      <div>
        <h2>Mute List is null</h2>
      </div>
    );
  }

  if (!mutedList) {
    return (
      <div>
        <h2>Mute List not found</h2>
      </div>
    );
  }

  if (Object.keys(mutedList).length === 0) {
    return (
      <div>
        <h2>Mute List is empty</h2>
      </div>
    );
  }

  return (
    <table className="mute-list">
      <thead>
        <tr>
          <th></th>
          <th>ID</th>
          <th></th>
          <th>Reason</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(mutedList).map(([id, reason]) => (
          <tr key={id}>
            <td>
              <button onClick={() => {
                if (id.startsWith('SP')) {
                  navigate(`/${id}`);
                } else if (id.startsWith('0x')) {
                  navigate(`/${id}`);
                }
              }}><PageviewIcon color="secondary" /></button>
            </td>
            <td>{id.substring(0, 5) + '...' + id.substring(id.length - 5)}</td>
            <td>
              <button onClick={() => handleRemoveMute(id)}><PlaylistRemoveIcon color="secondary"/></button>
            </td>
            <td>{reason}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Muted;